import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API from '../../config/apiconfig';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userLoginSuccess } from '../../action/userActions';
import { userManagementApiLoader } from '../../action/loaderActions';

export const useLoginInstance = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isErros,setIsErros] = useState([]);
  const currentUser = useSelector((state) => state.user);
  
  const login = ({email,password}) => {
    dispatch(userManagementApiLoader({isUsermanagementLoader: true}));
    const data = {
      "email": email,
      "password": password
    };
    axios
      .post(
        `${API.USER_MANAGEMENT_API_BASE_URL}${API.USER_LOGIN_URL}`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',  
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBSCRIPTION_KEY,
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.message, {
          autoClose: 6000,
        });
        console.log(response.data);
        dispatch(userLoginSuccess({...currentUser, isLoggedIn: true, accessToken: response?.data?.data?.access_token, refreshToken: response?.data?.data?.refresh_token}));
        dispatch(userManagementApiLoader({isUsermanagementLoader: false}));
        navigate('/myaccount/myprofile');
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || 'Error logging in!', {
          autoClose: 6000,
        });
        console.error('Error logging in:', error.response || error);
        dispatch(userManagementApiLoader({isUsermanagementLoader: false}));
        setIsErros(error?.response?.data?.errors);
      });
  };
  

  return { login, isErros};
};
